import { ElementData } from "@/components/form-builder/utils/types";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import TableRowInputs from "./TableInputTypes";
import { useTranslations } from "use-intl";
type TableInputProps = {
  elementId: string;
  extraAttributes: ElementData["element"]["extraAttributes"];
  label?: string;
  disabled?: boolean;
};
const TableInput = ({
  elementId,
  extraAttributes,
  label,
  disabled
}: TableInputProps) => {
  const t = useTranslations();
  const form = useFormContext();
  const tableInputs = useFieldArray({
    control: form.control,
    name: elementId
  });
  useEffect(() => {
    if (tableInputs.fields.length === 0 && !disabled) {
      tableInputs.append(Object.fromEntries(extraAttributes!.columns?.map(col => [col.id, ""]) || []), {
        shouldFocus: false
      });
    }
  }, [extraAttributes, extraAttributes?.columns, tableInputs, disabled]);
  const columns = extraAttributes?.columns?.sort((a, b) => a.displayOrder - b.displayOrder) || [];
  const showAddRowButton = !disabled && (!extraAttributes?.maxRows || tableInputs.fields.length < extraAttributes.maxRows);
  return <>
      <h1 className="text-lg font-bold">{label}</h1>
      {tableInputs.fields.map((tableField, index) => {
      return <div key={tableField.id} className="flex items-center justify-between gap-2">
            <div className="w-full">
              <p className="m-0 px-3 font-bold">
                {t("row_label_20230802124535", {
              index: index + 1
            })}
              </p>
              <div className="grid grid-flow-row-dense grid-cols-12 gap-3 xs:my-3 tablet:my-3">
                <TableRowInputs elementId={elementId} rowIndex={index} disabled={disabled} columns={columns} />
              </div>
            </div>
            {!disabled && <X size={30} className="cursor-pointer hover:text-red-500" onClick={() => {
          if (tableInputs.fields.length > 1) {
            tableInputs.remove(index);
          }
        }} />}
          </div>;
    })}
      {showAddRowButton && <Button type="button" onClick={() => {
      if (extraAttributes?.maxRows && tableInputs.fields.length >= extraAttributes.maxRows) {
        return;
      }
      tableInputs.append(Object.fromEntries(extraAttributes!.columns!.map(col => [col.id, ""])));
    }}>
          {t("src_components_form_viewer_inputs_TableInput_tsx_1")}
        </Button>}
    </>;
};
export default TableInput;